import styled, { css } from 'styled-components';
import { em } from 'polished';
import { colors } from 'core/theme';

const MAP = {
  h1: [36, 44],
  h2: [34, 40],
  h3: [24, 32],
  h4: [20, 28],
  h5: [18, 24],
  h6: [16, 20], // vadlīnjās nav definēts
}

const fontSize = ({level}) => {
  const tag = `h${level}`;
  return MAP[tag];
};

const fontSizeInEm = ({level}) => {
  const [fontSizeInPx] = fontSize({level});
  return em(fontSizeInPx);
};

const lineHeight = ({level}) => {
  const [fontSizeInPx, lineHeightInPx] = fontSize({level});
  return lineHeightInPx / fontSizeInPx;
};

export const HeadingStyle = (props) => css`
  color: ${colors.text};
  font-size: ${fontSizeInEm(props)};
  line-height: ${lineHeight(props)};
  margin-top: 0;
  margin-bottom: 0.75em;
  * + & {
    margin-top: 1.5em;
  }

  @media print {
    margin-bottom: 0.5em !important;
  }
`;

export const HeadingBase = styled.h1`
  ${props => HeadingStyle(props)};
`;

export const withTag = (tag) => (
  HeadingBase.withComponent(tag)
);



// WEBPACK FOOTER //
// ./src/elements/Heading/styled.js